/* eslint-disable @typescript-eslint/naming-convention */
export interface AbsorbDepartmentDto {
  Id: string;
  Name: string;
  UseDepartmentContactDetails: boolean;
  CompanyName: string;
  PhoneNumber: string;
  EmailAddress: string;
  ExternalId: string;
  ParentId: string | null;
  CurrencyId: string | null;
}
